export const appName = 'oo-ing'
export const appDescription = 'oo-ing'
